import { PushMessageListFilters } from "@myapp/contract";
import { useInfinitePaginated } from "../../../../shared/hooks/useInfinitePaginated";
import { notificationKeys } from "../notification.keys";
import { notificationApi } from "../service";

/** Broadcast history, newest first. */
export function usePushMessagesInfiniteQuery(filters: PushMessageListFilters = {}) {
  return useInfinitePaginated({
    queryKey: notificationKeys.messages(filters),
    params: filters,
    fetchFn: ({ page, ...rest }) =>
      notificationApi.listMessages({ ...rest, page }).then((response) => response.data),
  });
}
